const en = {
  services: {
    resume_parser: 'Resume Parser',
    resume_score: 'Resume Matcher',
    resume_review: 'Resume Checker',
    company_data: 'LinkedIn Company Scraper',
    profile_data: 'LinkedIn Profile Scraper',
    youtube_keywords: 'YouTube Keyword Tool',
    youtube_suggestions: 'YouTube Suggestions',
    youtube_title: 'YouTube Title Generator',
    youtube_description: 'YouTube Description Generator',
    youtube_hashtags: 'YouTube Hashtags',
    magical_resume_score: 'Magical Resume Matcher',
    youtube_seo: 'YouTube SEO',
    'youtube-title': 'YouTube Title Generator',
    'youtube-description': 'YouTube Description Generator',
    'youtube-hashtags': 'YouTube Hashtags',
    'resume-parser': 'Resume Parser',
    'resume-score': 'Resume Matcher',
    'resume-review': 'Resume Checker',
    'company-data': 'LinkedIn Company Scraper',
    'profile-data': 'LinkedIn Profile Scraper',
    'youtube-keywords': 'YouTube Keyword Tool',
    'youtube-suggestions': 'YouTube Suggestions',
    'magical-resume_score': 'Magical Resume Matcher',
    'youtube-seo': 'YouTube SEO',
  },
  global: {
    copied: 'Copied',
    usage: 'Usage',
    go_to_website: 'go to website',
    beta: 'Beta',
    try_it_now: 'Try it now',
    all_services: 'All Services',
    more_details: 'More Details',
    upgrade: 'Upgrade',
    yearly: 'Yearly',
    save: 'Save',
    monthly: 'Monthly',
    playground: 'Playground',
    subscribed: 'Subscribed',
    unsubscribed: 'unsubscribed',
    documentation: 'Documentation',
    history: 'History',
    clear: 'Clear',
    copy: 'Copy',
    jsonView: 'JSON View',
    formattedView: 'Formatted View',

    copy_data: 'Copy data',
    clear_data: 'Clear data',
    clear_history: 'Clear History',
    accepted_file_types: 'Accepted File Types:',
    install_chrome_extension: 'Install Chrome Extension',
    extension: 'Extension',
    examples: 'Free Examples',
    examples_text: 'What do you need right now?',
    profile: 'Profile',
    select_language: 'Select Language',
    dark_light: 'Dark / Light',
    services_playground: 'Services Playground',
    upgrade_to: 'Upgrade to',
    pro: 'Pro',
    basic: 'Basic',
    free: 'Free',
    learn_more: 'Learn more',
    upgrade_api: 'Upgrade to the Pro plan now to access the API Key',
  },
  support: {
    support: 'Support',
    access_api: 'Access to API',
  },
  home: {
    wellcome_first: 'Welcome to the',
    wellcome_second: 'MagicalAPI Playground',
  },
  home_panel: {
    help_center: 'Help Center',
    help_center_description: 'Frequently asked account and billing questions',
    first_card_title: 'Try the Playground',
    first_card_description: 'Try out services with live data and tools',
    second_card_title: 'API Documentation',
    second_card_description:
      'Developer guides and references for seamless integration',
    third_card_title: 'API Keys',
    third_card_description:
      'Generate and manage your secure access credentials',
    fourth_card_title: 'Status',
    fourth_card_description: 'Check the status of MagicalAPI services',
    my_services_title: 'My Services',
    drag_reorder_hint: 'Drag to reorder • Click + to add more services',
  },
  alert: {
    verified_email:
      "To get 50 free credits verify your email address. A verification link has been sent to your email address. Didn't receive an email?",
    magical_resume_score_alert:
      'If the LinkedIn URL field is empty, this service will search for the LinkedIn URL in the resume file.If the URL is found, the score will be calculated based on the data from both the resume and LinkedIn.',
    forgot_password: 'We have emailed your password reset link!',
    been_verified_email: 'Your email has been verified',
    email_verification_failed: 'Email Verification Failed',
    start_text: 'You can start exploring MagicalAPI Services:',
    resume_parser_alert:
      'We provide our best support for English and French resume files. Please note that for other languages, we cannot guarantee the same level of quality in our responses.',
  },
  navbar: {
    beta: 'BETA',
    logout: 'Logout',
    login: 'Login',
    sign_up: 'Sign Up',
    pricing: 'Pricing',
    all_services: 'All Services',
    panel: 'Panel',
    playground: 'Playground',
    website: 'Website',
  },
  button_text: {
    back_home: 'Back Home',
    submit: 'submit',
    resend: 'resend',
    reset: 'reset',
    login: 'login',
    sign_up: 'sign up',
    send: 'send',
    proceed_to_payment: 'Proceed to Payment',
    request_more_credit: 'Buy Credits',
    payment: 'pay',
    back: 'back',
    next: 'Next',
    find_keywords: 'Find Keywords',
    extract_data: 'Extract Data',
    generate: 'Generate',
    generate_title: 'Generate Titles',
    generate_keywords: 'Generate Keywords',
    generate_captions: 'Generate Captions',
    generate_hashtags: 'Generate Hashtags',
    calculate_score: 'Calculate Score',
    seo_checkup: 'SEO Checkup',
    scan_my_resume: 'Scan My Resume',
    scan_resume: 'Scan Resume',
    revoke: 'Revoke',
    view_invoice: 'View invoice',
    buy_now: 'Buy now',
  },
  layout_playground: {
    get_ideas: 'Get Ideas',
    get_answer: 'Get Answer',
    empty_title: 'Answer the prompts',
    empty_text:
      'Get the best results by trying multiple inputs and of varying lengths.',
    get_code: 'Do you want to use in code?',
    please_wait: 'Please Wait',
    please_wait_text_first: 'This may take a while.',
    please_wait_text_second: 'Thanks for waiting',
    usege_credit: 'Credits used',
    try_it_now: 'Try it now',
    learn_more: 'Learn more',
  },
  sign_up: {
    linkHelperText: 'Login now',
    linkHelperMessage: 'Already have an account',
    title: 'Sign Up',
    input_email_placeholder: 'Email',
    input_first_name_placeholder: 'First name',
    input_Last_name_placeholder: 'Last name',
    input_password_placeholder: 'Password',
    input_confirem_password_placeholder: 'Password Confirmation',
    required_email: 'The email is required',
    required_password: 'The password is required',
    required_last_name: 'The last name is required',
    required_first_name: 'The first name is required',
    inValid_email: 'The email is not valid',
    lenght_password: 'The password length must be at least 8 characters',
    required_confirm_password: 'The password confirmation is required',
    password_not_match: 'The password confirmation does not match',
    i_agree_with: 'I agree with',
    terms: 'terms',
    and: 'and',
    policies: 'policies',
  },
  login: {
    linkHelperText: 'Sign Up',
    linkHelperMessage: 'Don’t have an account?',
    title: 'Login',
    forgot_password: 'Forgot password?',
    remember: 'Remember mre',
    input_email_placeholder: 'Email',
    input_password_placeholder: 'Password',
    required_email: 'The email is required',
    inValid_email: 'The email is not valid',
    required_password: 'The password is required',
    continue_with: 'Continue with',
  },
  forgot_password: {
    linkHelperText: 'Sign Up',
    linkHelperMessage: 'Back to ',
    title: 'Forgot Password',
    text: 'Input your registered email to reset your password',
    input_email_placeholder: 'Email',
    required_email: 'The email is required',
  },
  reset_password: {
    linkHelperText: 'Login now',
    linkHelperMessage: 'Know your password?',
    title: 'New Password',
    input_password_placeholder: 'New Password',
    input_password_confirm_placeholder: 'Confirm New Password',
    text: 'Send your email account to reset password and make new password',
    required_password: 'The password is required',
    required_password_confirem: 'The password confirm is required',
    not_same_passwords: 'The password confirmation is not same password',
  },
  stepper: {
    heading: 'Help us align the platform with your needs',
    firstStepTitle: 'Will you use MagicalAPI?',
    secondStepTitle: 'Select the Services you need',
    thirdStepTitle: 'Unlock your Free Trial benefits',
  },

  //not added to other languages
  sidebar: {
    dashboard: 'Dashboard',
    services: 'Services',
    usage: 'Usage',
    requests: 'Requests',
    billing: 'Billing',
    fqa: 'FAQ',
    documentation: 'Documentation',
    apiInfo: 'API & Webhook',
    settings: 'Settings',
    pricing: 'Pricing',
    Panel: 'panel',
    Playground: 'Playground',
    resume: 'Resume Services',
    resumeParser: 'Resume Parser',
    resumeReview: 'Resume Checker',
    resumeScore: 'Resume Matcher',
    youtube: 'Youtube',
    youtubeSEO: 'SEO',
    youtubeKeyword: 'Keyword Tool',
    youtubeTitle: 'Title Generator',
    youtubeDescription: 'Description Generator',
    youtubeHashtags: 'Hashtags',
    data: 'Data Services',
    dataLinkedInProfile: 'LinkedIn Profile Scraper',
    dataLinkedInCompany: 'LinkedIn Company Scraper',
    resumeServices: 'Resume Services',
    dataServices: 'Data Services',
    whatsNew: `What's new`,
  },
  not_found: {
    title: 'Page Not Found',
    first_text: 'We’re sorry, The page you requested could not be found.',
    second_text: 'please go back to the homepage',
  },
  internal_error: {
    title: 'Oops! Something went wrong',
    first_text: 'Server error 500. We apologize and are fixing the problem. ',
    second_text: 'please try again at a later stage',
  },
  api_key: {
    api_key: 'API key',
    copied: 'Copied',
    api_key_text:
      'API Key is a unique identifier that will grant you access to our APIs and enable you to integrate our services into your applications seamlessly.',
    api_key_alert:
      'We only show this to you once. If you forget it, you’ll need to generate a new one.',
  },
  latest_requests: {
    latest_requests: 'Latest Requests',
    services_name: 'Services Name',
    date: 'Date',
    time: 'Time',
  },
  api_info: {
    page_heading: 'API Info',
    you_need_key: 'You need an API Key to send requests via MagicalAPI',
    btn_generate: 'Generate API Key',
    table_header_title: 'Title',
    table_header_key: 'Key',
    table_header_added: 'Added',
    input_error: 'Enter a title for Api Key',
    input_placeholder: 'Title',
    new_key_title: 'Title',
    input_max_error: 'Title must be at most 50 characters',
    delete_modal_header: 'Remove API Key',
    delete_modal_confirm_btn: 'Yes, remove it',
    delete_modal_cancel_btn: 'Cancel',
    delete_modal_description:
      'Are you sure you want to remove this API Key? This action can not be ',
    delete_modal_description_pt2: 'undone.',
    alert:
      'We only show this to you once. If you forget it, you’ll need to generate a new one.',
  },
  total_tokens: {
    total_tokens: 'Total Credits',
  },
  layout_playground: {
    get_ideas: 'Get Ideas',
    get_answer: 'Get Answer',
    empty_title: 'Answer the prompts',
    empty_text:
      'Get the best results by trying multiple inputs and of varying lengths.',
    get_code: 'Do you want to use in code?',
    please_wait: 'Please Wait',
    please_wait_text_first: 'This may take a while.',
    please_wait_text_second: 'Thanks for waiting',
    usege_credit: 'Credits used',
  },
  payment: {
    order_summery: 'Order Summery',
    credits: 'Credits',
    per_month: '/ per month',
    payment_methods: 'Select your payment method',
    cryptocurrency: 'Cryptocurrency',
    credit_card: 'Credit / Debit Card',
    order_summery_text:
      'Review your selected plan and finalize your purchase. Get a comprehensive overview of your chosen plan before proceeding.',
    monthly_access: 'Monthly access',
    selected_plan: 'Selected plan is',
    amount_due: 'Amount due in 7 days',
    amount_due_today: 'Amount due today',
    cancel_anytime: 'Cancel anytime you want',
    get_more: 'Get More',
    credits_get_more: 'Credits',
    total_amount: 'Total Amount',
  },
  cryptocurrency: {
    required_coin: 'The coin is required',
    input_selected_coin_placeholder: 'Selected coin',
  },
  credit_card: {
    credit_card_coming_soon: 'Coming Soon...',
    credit_card_coming_soon_text:
      "We're working diligently to bring you the convenience of paying with credit cards. Stay tuned for our upcoming credit card payment method, expanding your options for seamless transactions.",
  },
  payment_success: {
    title: 'Your payment is successful',
    text: 'Thank you for choosing MagicalAPI',
    processing_your_title: 'Processing your subscription...',
    processing_your_payment: 'Processing your payment...',
    processing_your_text: 'Please wait, we are processing your subscription',
    processing_your_payment_text: 'Please wait, we are processing your payment',
    subscription_activated_title: 'Your payment is successful.',
    subscription_activated_button: "Let's get started",
    back_home_button: 'Back Home',
    back_to_assistant_button: 'Back to Assistant',
    being_processed_title: 'Your Subscription is Being Processed',
    being_processed_text:
      "Your payment is being securely handled, and we'll notify you as soon as it's complete.",
    being_processed_button: 'Go to Dashboard',
  },
  payment_failed: {
    title: 'Please Try Again',
    text: 'Sorry, We had an issue gathering your payment',
  },
  login_modal: {
    welcome_to_the: 'Welcome to the',
    magicalapi: 'MagicalAPI',
    text: 'Login with your MagicalAPI account to continue',
  },
  youtube_suggestion: {
    title: 'YouTube Suggestions',
    example_input_suggestion:
      'Example: How to create a profitable Shopify store',
    input_suggestion_placeholder: 'Describe your YouTube video content',
    input_goal_placeholder: 'Select a goal: ',
    input_number_placeholder: 'Outputs: ',
    required_description: 'Video description is required',
    minimum_description:
      'Your video description is too short(minimum 10 characters)',
    maximum_description:
      'Your video description is too long(maximum 500 characters)',
    required_goal: 'Goal is required',
    required_number: 'Output count is required',
    minimum_count_description: 'min : 1 , max : 3',
    minimum_count_title: 'min : 2 , max : 10',
    minimum_count_hashtags: 'min : 5 , max : 20',
    minimum_count_keywords: 'min : 5 , max : 20',
    maximum_count_description: 'min : 1 , max : 3',
    maximum_count_title: 'min : 2 , max : 10',
    maximum_count_hashtags: 'min : 5 , max : 20',
    maximum_count_keywords: 'min : 5 , max : 20',
  },
  youtube_title: {
    discribe_videos: 'Describe your video:',
    tone: 'Tone:',
    title: 'YouTube Title Generator',
    example_input_suggestion: 'Example: ss',
    input_suggestion_placeholder: 'Describe your YouTube video content',
    input_goal_placeholder: 'Select a tone: ',
    input_number_placeholder: 'Outputs: ',
    required_description: 'Video description is required',
    minimum_description:
      'Your video description is too short (minimum 10 characters)',
    maximum_description:
      'Your video description is too long (maximum 500 characters)',
    required_goal: 'Goal is required',
    required_tone: 'Tone is required',
    required_number: 'Output count is required',
    minimum_count_description: 'min : 1 , max : 3',
    minimum_count_title: 'min : 2 , max : 10',
    minimum_count_hashtags: 'min : 5 , max : 20',
    minimum_count_keywords: 'min : 5 , max : 20',
    maximum_count_description: 'min : 1 , max : 3',
    maximum_count_title: 'min : 2 , max : 10',
    maximum_count_hashtags: 'min : 5 , max : 20',
    maximum_count_keywords: 'min : 5 , max : 20',
    get_titles: 'Get Titles',
  },
  youtube_description: {
    discribe_videos: 'Describe your video:',
    tone: 'Tone:',
    title: 'YouTube Description Generator',
    example_input_suggestion: 'Example: ss',
    input_suggestion_placeholder: 'Describe your YouTube video content',
    input_goal_placeholder: 'Select a tone: ',
    input_number_placeholder: 'Outputs: ',
    required_description: 'Video description is required',
    minimum_description:
      'Your video description is too short(minimum 10 characters)',
    maximum_description:
      'Your video description is too long(maximum 500 characters)',
    required_goal: 'Goal is required',
    required_tone: 'Tone is required',
    required_number: 'Output count is required',
    minimum_count_description: 'min : 1 , max : 3',
    minimum_count_title: 'min : 2 , max : 10',
    minimum_count_hashtags: 'min : 5 , max : 20',
    minimum_count_keywords: 'min : 5 , max : 20',
    maximum_count_description: 'min : 1 , max : 3',
    maximum_count_title: 'min : 2 , max : 10',
    maximum_count_hashtags: 'min : 5 , max : 20',
    maximum_count_keywords: 'min : 5 , max : 20',
    get_descriptions: 'Get Descriptions',
  },
  youtube_hashtags: {
    enter_keyword: 'Enter a keyword:',
    warning_lenght:
      ' For optimal results, please enter a topic or keyword of a word.',
    title: 'YouTube Hashtags',
    example_input_suggestion: 'Example: ss',
    input_suggestion_placeholder: 'Enter',
    input_goal_placeholder: 'Select a tone: ',
    input_number_placeholder: 'Outputs: ',
    required_description: 'Video description is required',
    minimum_description: 'Your keyword is too short (minimum 3 characters)',
    maximum_description: 'Your keyword is too long (maximum 50 characters)',
    required_goal: 'Goal is required',
    required_tone: 'Tone is required',
    required_number: 'Output count is required',
    minimum_count_description: 'min : 1 , max : 3',
    minimum_count_title: 'min : 2 , max : 10',
    minimum_count_hashtags: 'min : 5 , max : 20',
    minimum_count_keywords: 'min : 5 , max : 20',
    maximum_count_description: 'min : 1 , max : 3',
    maximum_count_title: 'min : 2 , max : 10',
    maximum_count_hashtags: 'min : 5 , max : 20',
    maximum_count_keywords: 'min : 5 , max : 20',
    get_hashtags: 'Get Hashtags',
    alert_length:
      'For optimal results, please enter a topic or keyword of two words or fewer.',
  },
  youtube_keyword: {
    enter_keyword: 'Enter a keyword:',
    title: 'YouTube Keyword Tool',
    tags: '(Tags)',
    example_input_keyword:
      'Examples: minecraft, music videos, movie trailers, etc.',
    input_keyword_placeholder: 'Enter Keyword',
    input_country_placeholder: 'Select a Country',
    input_language_placeholder: 'Select a Language',
    required_keyword: 'Keyword is required',
    country_require: 'Country is required',
    language_require: 'Language is required',
    minimum_keyword: 'Keyword is too short (minimum 3 characters)',
    maximum_keyword: 'Keyword is too long (maximum 50 characters)',
  },

  resume_score: {
    title: 'Resume Matcher',
    subtitle: 'Match your resume against job descriptions',
    description:
      'Get a detailed matching score and improve your hiring chances',
    required_resume: 'Resume file is required',
    required_skills: 'Skills are required',
    required_JobDescription: 'Job description is required',
    minimum_description: 'Job description is too short(minimum 100 characters)',
    maximum_description: 'Job description is too long(maximum 5000 characters)',
    file_size_maximum: 'Maximum uploading file size is 10MB',
    type_file_error: 'Only PDF , DOCX , DOC file supported',
    file: 'Upload',
    url: 'URL',
    file_url_label: 'Paste your File URL',
    input_file_placeholder: 'Choose or Drop Your File',
    input_url_placeholder: 'Enter URL https://...',
    required_resume_url: 'Resume file URL is required',
    invalid_url: 'Job description URL is invalid',
  },
  resume_parser: {
    title: 'Resume Parser',
    subtitle: 'Upload your resume and extract all data instantly',
    description: 'Extract key fields in seconds and simplify your workflow.',
    required_resume: 'Resume file is required',
    required_resume_url: 'Resume file URL is required',
    file_size_maximum: 'Maximum uploading file size is 10MB',
    type_file_error: 'Only PDF , DOCX , DOC file supported',
    file: 'Upload',
    url: 'URL',
    file_url_label: 'Paste your File URL',
    input_file_placeholder: 'Choose or Drop Your File',
    input_url_placeholder: 'Enter URL https://...',
  },
  youtube_seo: {
    title: 'YouTube SEO',
    required_resume: 'Resume file is required',
    required_resume_url: 'Video URL is required',
    file_size_maximum: 'Maximum uploading file size is 10MB',
    type_file_error: 'Only PDF file supported',
    file: 'Upload',
    url: 'URL',
    input_file_placeholder: 'Choose or Drop Your File',
    input_url_placeholder: 'Enter URL https://...',
    invalid_url: 'Video URL is invalid',
    watch_example: 'https://youtube.com/watch?v=VIDEO_ID',
    short_example: 'https://youtube.com/shorts/VIDEO_ID',
  },
  resume_review: {
    title: 'Resume Checker',
    subtitle: 'Upload your resume for detailed analysis',
    description:
      'Get comprehensive feedback and actionable insights to improve your resume',
    required_resume: 'Resume file is required',
    required_resume_url: 'Resume file URL is required',
    file_size_maximum: 'Maximum uploading file size is 10MB',
    type_file_error: 'Only PDF , DOCX , DOC file supported',
    file: 'Upload',
    url: 'URL',
    file_url_label: 'Paste your File URL',
    input_file_placeholder: 'Choose or Drop Your File',
    input_url_placeholder: 'Enter URL https://...',
  },

  profile_data: {
    title: 'LinkedIn Profile Scraper',
    subtitle: 'Enter a LinkedIn Profile URL',
    description: 'Extract comprehensive Profile Data data in seconds',
    linkedin_profile: 'Enter Linkedin Profile URL',
    required_username: 'LinkedIn Profile URL is required',
    input_username_placeholder: 'Linkedin profile URL',
    invalid_linkedin_url: 'LinkedIn URL is invalid',
  },
  company_data: {
    title: 'LinkedIn Company Scraper',
    subtitle: 'Enter a company name, website, or LinkedIn URL',
    description: 'Extract comprehensive company data in seconds',
    required_companyname: 'Company LinkedIn URL is required',
    input_placeholder: 'LinkedIn Company URL',
    invalid_linkedin_url: 'LinkedIn URL is invalid',
    company_website: 'Enter Company Website',
    company_name: 'Enter Company Name',
    linkedin_url: 'Enter Company Linkedin URL',
    company_name_switch: 'Name',
    company_website_switch: 'Website',
    linkedin_url_switch: 'Linkedin URL',
  },
  magical_resume_score: {
    title: 'Magical Resume Matcher',
    required_resume: 'Resume file is required',
    file_size_maximum: 'Maximum uploading file size is 10MB',
    type_file_error: 'Only PDF , DOCX , DOC file supported',
    required_skills: 'Skills are required',
    file: 'Upload',
    url: 'URL',
    input_file_placeholder: 'Choose or Drop Your File',
    input_url_placeholder: 'Enter URL https://...',
    input_linkedin_profile_name_placeholder: 'Linkedin profile name',
  },
  get_more_credits: {
    get_more_credits: 'Get More Credits',
    select_credits_you_need: 'Select credits you need',
  },
  get_more_credits_page: {
    get_more_credits: 'Get More Credits',
    select_amount_to_buy: 'Select the amount of credits you want to buy',
    buy_now_button: 'Buy Now',
    details_box_title: 'Details',
    details_box_credits_lbl: 'Credits',
    details_box_price_lbl: 'Price',
    details_box_total_amount_lbl: 'Total amount',
    no_credits_left_box: `You don't have any Credits, You'll need to buy more Credits!`,
    btn_buy_more_credits: `Buy more credits`,
    btn_buy_now: `Buy Now`,
  },
  invoice_table: {
    invoices: 'Invoices',
    invoice_id: 'Invoice ID',
    date: 'Date',
    amount: 'Amount',
    plan: 'Plan',
    status: 'Status',
    action: 'Action',
    pending: 'pending',
    paid: 'paid',
    failed: 'failed',
    month: 'Month',
  },
  invoice_details: {
    title: 'Invoice Details',
    payment_for: 'Payment for',
    date: 'Creation Date',
    plan: 'Plan',
    tax: 'Tax',
    discount: 'Discount',
    total_amount: 'Total Amount',
    status: 'Status',
    payment_date: 'Payment Date',
    ok_btn: 'Ok',
    download_pdf_btn: 'Download PDF',
    credits_per_month: 'Credits/m',
    paid: 'paid',
    failed: 'failed',
  },

  month: {
    jan: 'Jan',
    feb: 'Feb',
    mar: 'Mar',
    apr: 'Apr',
    may: 'May',
    jun: 'Jun',
    jul: 'Jul',
    aug: 'Aug',
    sep: 'Sep',
    oct: 'Oct',
    nov: 'Nov',
    dec: 'Dec',
  },
  service_chart: {
    last_month: 'Last Month',
    last_year: 'Last Year',
    dropdown_placeholder: 'Last Month',
  },
  fallback: {
    title: 'Oops! Something went wrong',
    subtitle: 'Server error 500. We apologize and are fixing the problem.',
    text: 'please try again at a later stage',
    contact_support: 'Contact Support',
    reload_page: 'Reload Page',
  },
  menu_help: {
    online_support: 'Online Support',
    contact_us: 'Contact us',
    request_feature: 'Request a feature',
    join_discord: 'Join our Discord',
  },
  plan_info: {
    your_plan: 'Your plan is',
    left_until: 'left until',
    left: 'left',
    used: 'Used',
    total_credits: 'Total credits',
    extra_credits: 'Extra credits',
    credits: 'credits',
    next_bill: 'next bill at',
    on: 'on',
    credits_month: 'credits/month',
    current: 'Current',
    plan: 'Plan',
    cancel_subscription: 'Cancel subscription',
    credits_used: 'Credits used',
    renewed_at: 'next renewal at',
    billing_period: 'Billing period',
  },
  trial_plan: {
    trial_plan_active: 'Trial Plan Active',
    explore_features: 'Explore all premium features',
    days_left: 'days left',
    trial_ends_on: 'Trial ends on',
    whats_included: "What's included in your trial:",
    credits: 'Credits',
    all_services_access: 'All services access',
    available_for_days: 'Available for {{days}} days',
    credits_used: 'Credits Used',
    upgrade_to_pro: 'Upgade To Pro',
    compare_plans: 'Compare plans',
  },
  description_services_suggestion: {
    company_data: 'Do you like to get <span>Company page</span> data?',
    youtube_keyword:
      'Do you like to get <span>more views</span> on <span>YouTube</span>?',
    profile_data:
      'Do you like to explore <span>LinkedIn Profile</span> insights?',
    resume_parser: 'Do you like to extract data from <span>Resume file</span>?',
    resume_review: 'Do you like to analyze <span>your Resume</span>?',
    resume_score:
      'Do you like compare <span>your resume</span> to a <span>Job</span>?',
    youtube_seo: 'Do you like to check <span>Video SEO</span>?',
    youtube_suggestions:
      'Do you like to optimize your <span>YouTube content</span>?',
    youtube_title: 'Do you like to optimize your <span>YouTube Title</span>?',
    youtube_description:
      'Do you like to optimize your <span>YouTube Description</span>?',
    youtube_hashtags:
      'Do you like to optimize your <span>YouTube Hashtags</span>?',
  },
  pricing: {
    monthly: 'Monthly',
    yearly: 'Yearly',
    save: 'Save',
    start_your: 'Start your',
    free_trial: 'Free Trial',
    trial_info: '2,000 Credits in 7 days',
    most_popular: 'Most popular',
    per_month: 'per month',
    current_plan: 'Current Plan',
    try_for_free: 'Try for Free',
    business: 'Business plan',
    business_description:
      'It is ideal for businesses needing extra credits and full support. Reach out to our sales team for customized solutions and special perks.',
    contact_sales: 'Contact Sales',
    request_demo: 'Request a demo',
    account_features: 'Account Features',
    each_request_uses: 'Each request uses',
    credits: 'Credits',
    request: 'Requests /mo',
    limited_response: 'Limited Response',
    buy_now: 'Buy Now',
  },
  profile: {
    setting: 'Account',
    profile: {
      first_name: 'First Name',
      last_name: 'Last Name',
      display_name: 'Display Name',
      email_address: 'Email Address',
      signup_date: 'Signup Date',
    },
    tab: {
      account_info: 'Account Info',
      payment: 'Payment',
    },
    payment: {
      next_plan: 'Next plan',
      monthly: 'Monthly',
      activate_now: 'Activate Now',
      current_plan: 'Current plan',
      compare_plans: 'Compare plans',
      received: 'Received',
      expires: 'Expires',
      credits: 'Credits',
      ends_at: 'Ends at',
      next_billed_on: 'Next billed on',
      your_subscription: 'Your Subscription is Being Processed',
      subscription_activated: 'Subscription activated successfully!',
      activate_plan: 'Activate Plan',
      active_plan_one: 'Are you sure you want to end trial plan?',
      active_plan_two: 'This action can not be',
      active_plan_three: 'undone',
      stay_trial: 'Stay on trial',
      yes_activate: 'Yes, Activate it',
      manage_subscription: 'Manage your subscription',
      manage_subscription_text:
        'Your current subscription will remain active until the end of the billing period, allowing you to continue enjoying our services until then. Please note that this action will not issue a refund for the current subscription period, but will ensure that your subscription does not automatically renew.',
      cancel_renewal: 'Cancel Renewal',
      cancel_renewal_text_one:
        'Are you sure you want to cancel your subscription?',
      cancel_renewal_text_two: 'This action can not be ',
      cancel_renewal_text_tree: 'undone',
      stay_subscribed: 'Stay subscribed',
      yes_cancel: 'Yes, Cancel it',
      change_profile: 'Change Profile Picture in',
      gravatar: 'Gravatar',
    },
  },
  services_page: {
    credit_request: 'credit per request',
    pricing: 'Pricing',
    total_requests: 'Total Requests',
  },
  usage_page: {
    page_heading: 'Usage',
    chart_heading: 'Requests',
    pricing: 'Pricing',
    total_requests: 'Total Requests',
  },
  billing_page: {
    page_heading: 'Billing',
  },
  billing: {
    tab: {
      pricing: 'Pricing',
      invoices: 'Invoices',
      payment: 'Overview',
    },
  },
  upgrade_box: {
    try: 'Try',
    plan_free: 'plan for Free',
    upgrade_to: 'Upgrade to',
    starting_trial_plan:
      'Start Trial plan right now for Free to instantly get All the data!',
    basic_plan_text:
      'Upgrade To Basic plan right now to instantly get All the data!',
    pro_plan_text:
      'Upgrade To Pro plan right now to instantly get All the data!',
    start_free: 'Start for free',
    active_trial: 'Activate Trial',
    upgrade_now: 'Upgrade Now',
    upgrade_to_plan: 'Upgrade To {{planName}}',
    plan_label: '{{planName}} Plan',
    features: {
      premium_features: 'Unlock premium features and insights<span class="instantly-text"> instantly</span>.',
      no_credit_card: 'No credit card required, Cancel anytime.',
      all_services_access: 'Access to all Magical API services.',
      free_credits_trial: 'Get 2,000 credits free for 7 days.',
    },
    upgrade_basic: 'Upgrade to Basic',
    try_for_free: 'Try for Free',
    upgrade_pro: 'Upgrade to Pro',
  },
  free_plan: {
    your_plan: 'Your plan is',
    upgrade_to: 'Upgrade to',
    plan: 'plan',
    try: 'Try',
    every_thing: 'Every thing in Free, and:',
    compare_plans: 'Compare plans',
    credits: '2,000 Credits',
    services_access: 'All services access',
    availability: 'Available for 7 days',
    api_access: 'Access to API',
  },

  updating: {
    title: 'We’re updating our system',
    first_text: "We're making improvements to enhance your experience.",
    second_text: 'Please drink a coffee and check back soon',
  },
  product: {
    data: 'Magical Data',
    resume: 'Magical Resume',
    youtube: 'Magical YouTube',
    data_single: 'Data',
    resume_single: 'Resume',
    youtube_single: 'YouTube',
    services: 'Services',
  },
  verifay_email: {
    please_verify: 'Please verify your email',
    verify_text: 'Your almost there! We sent an email to',
    just_click:
      'Just click on the link in that email to complete your signup. If you don’t see it, you may need to',
    check_spam: 'check your spam',
    folder: 'folder',
    no_problem: 'Still can’t find the email? No problem',
    resend_email: 'Resend email',
    wrong_email: 'Wrong email',
    sign_out: 'Sign out',
  },
  manual_invoices: {
    order_summary_title: 'Invoice details',
    amount_due_title: 'Amount due',
  },
  no_data: {
    chart_heading: 'No data source for this report',
    chart_description: `You haven't made any requests yet. Start exploring MagicalAPI's powerful features now!`,
    first_req_btn: 'Send Your First Request',
    no_invoices_heading: 'No Invoices Yet',
    no_invoices_description:
      'Your invoices will appear here once you start using paid services.',
    no_api_key_heading: 'No API Keys Found',
    no_api_key_description: 'All of API Keys generated will appear here.',
  },
  drag_drop: {
    drop_file_here: 'Drop Your File Here.',
    valid_file: 'Valid file detected',
    invalid_file: 'Invalid file type.',
    release_to_upload: 'Release to upload',
    file_requirements: 'PDF or DOC files only, max 10MB',
    supported_formats: 'Supported: PDF, DOC, DOCX (max 10MB)',
    drag_drop_text: 'Drag and drop your resume here or',
    click_to_upload: 'click to upload',
    remove_file: 'Remove File',
    upload_your_resume: 'Upload Your Resume',
    accepted_file_types: 'Accepted File Types: PDF, DOCX, DOC  (10 MB)',
  },
};

export default en;
